export default __webpack_public_path__ + "static/media/toyota3.b17edcb2.png";